// // import dynamic from "next/dynamic";
// import React, { Suspense, useEffect, useState } from "react";
// // import NextProgress from "next-progress";
// import HeaderSkeleton from "../../ui/Skeletons/HeaderSkeleton";
// import useOnlineStatus from "../../hooks/useDetectOnline";
// // import Sidebar from "../Sidebar/Sidebar";
// // import { FadeLoader } from "react-spinners";
// import { Backdrop, Box } from "@mui/material";
// import assest from "../../json/assest";
// // import Image from "next/image";
// import UserHeader from "../UserHeader/UserHeader";
// import UserSidebar from "../UserSidebar/UserSidebar";
// import UserFooter from "../UserFooter/UserFooter";
// import { lazy } from "react";

// const UseHeader = lazy(() => import("../UserHeader/UserHeader"), { suspense: true });
// const Footer = lazy(() => import("../Footer/Footer"), { suspense: true });


// const UserWrapper = (props) => {
//     const { children } = props;
//     let [loading, setLoading] = useState(true);
//     const handleClose = () => {
//         setLoading(false);
//     };
//     useOnlineStatus();
//     useEffect(() => {
//         if (loading) {
//             setTimeout(() => {
//                 setLoading(false);
//             }, 2000);
//         }
//     }, [loading]);
//     return (
//         <>
//             <Backdrop
//                 sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
//                 open={loading}
//                 onClick={handleClose}
//                 className="loader"
//             >
//                 {/* <FadeLoader color="#5C5C5C" /> */}
//                 <div className="loader-wrapper">
//                     <div className="loaderIcon">
//                         <img
//                             src={assest.logo_loader}
//                             alt="img"
//                             width={100}
//                             height={100}
//                         />
//                     </div>
//                 </div>
//             </Backdrop>

//             {/* <NextProgress height={8} color="green" /> */}
//             <Suspense fallback={<HeaderSkeleton />}>
//                 <UserHeader headerPurchaseBtn={props?.headerPurchaseBtn} />
//             </Suspense>

//             <Suspense>
//                 <UserSidebar />
//             </Suspense>

//             {children}

//             <Suspense fallback={<HeaderSkeleton />}>
//                 <UserFooter footerChatBtn={props?.footerChatBtn} />
//             </Suspense>
//         </>
//     )
// }

// export default UserWrapper

import { Box, Stack } from '@mui/material'
import React from 'react'
import UserHeader from '../UserHeader/UserHeader'
import styles from '../../styles/layout/contentbuyerdashboard/content-buyer-dashboard-wrapper.module.scss'
import UserFooter from '../UserFooter/UserFooter'
import UserSidebar from '../UserSidebar/UserSidebar'

export default function UserWrapper({ footerChatBtn = false, children, headerPurchaseBtn = false }) {
    
    return (
        <>
            <UserHeader headerPurchaseBtn={headerPurchaseBtn} />
            <Stack direction={'row'} className={styles.contentbuyerDashboardSiderbarBody}>
                <Box className={styles.contentbuyerDashboardSidebar}>
                    <UserSidebar />
                </Box>
                <Box className={styles.contentbuyerDashboardBody}>{children}</Box>
            </Stack>
            <UserFooter footerChatBtn={footerChatBtn} />
        </>
    )
}
